import React from "react";
import { FileTextIcon, ClipboardCheckIcon, ImageIcon, Table2Icon, CameraIcon, GraduationCapIcon } from "lucide-react";
import { SectionHeading } from "../SectionHeading";
import { CtaButton } from "../CtaButton";
import { toolkit } from "../../data/content";
const iconMap = {
  template: FileTextIcon,
  check: ClipboardCheckIcon,
  visual: ImageIcon,
  matrix: Table2Icon,
  camera: CameraIcon,
  book: GraduationCapIcon
};
export function Toolkit() {
  return <section className="bg-paper px-5 py-16 sm:py-20" data-id="element-266" data-mp="27dyvr9j84oc2">
      <div className="mx-auto max-w-5xl" data-id="element-267" data-mp="2cdla5masgamg">
        <SectionHeading tone="light" title="Your Complete Occlusion Blueprint Toolkit" subtitle="In addition to the six volumes, you'll receive practical resources designed to make the system easier to navigate." data-id="element-268" data-mp="2h5mkh2oebr9u" />
        <ul className="divide-y divide-slate-200 overflow-hidden rounded-3xl bg-white ring-1 ring-slate-200" data-id="element-269" data-mp="2r53n1b8cpp1l">
          {toolkit.map(t => {
          const Icon = iconMap[t.icon];
          return <li key={t.title} className="flex items-start gap-4 p-5 sm:p-6" data-id="element-270" data-mp="20y4n4enc98h4">
                <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-brand/15 text-brand-dark" data-id="element-271" data-mp="1vwf9cr8qegpc">
                  <Icon className="h-6 w-6" aria-hidden="true" data-id="element-272" data-mp="1qym5i4uwhys8" />
                </span>
                <div data-id="element-273" data-mp="1m0u32gwmqu9s">
                  <h3 className="font-display text-lg font-extrabold text-ink-900" data-id="element-274" data-mp="1m1dpa9tbc4tm">{t.title}</h3>
                  <p className="mt-1 text-[15px] leading-relaxed text-slate-600" data-id="element-275" data-mp="2jp468z85jo2h">{t.text}</p>
                </div>
              </li>;
        })}
        </ul>
        <p className="mx-auto mt-8 max-w-2xl text-center text-base font-semibold text-ink-900" data-id="element-276" data-mp="29vx3zn8pko6m">
          Everything is organized to help you move from scattered notes to a clearer, more consistent way of working.
        </p>
        <div className="mt-10" data-id="element-277" data-mp="32flxezdc6blq">
          <CtaButton label="I Want the Complete Toolkit" tone="light" data-id="element-278" data-mp="2xn2inz2wxafc" />
        </div>
      </div>
    </section>;
}